/**
 * One icon set, one component.
 *
 * Inline SVG paths rather than an icon package: this app needs about thirty
 * glyphs, and a dependency would ship several hundred. `currentColor`
 * throughout, so an icon always matches the text it sits beside.
 */

const PATHS = {
  // navigation
  dashboard: 'M3 3h7v9H3V3Zm0 11h7v7H3v-7Zm9 0h9v7h-9v-7Zm0-11h9v9h-9V3Z',
  truck: 'M2 7h11v9H2V7Zm11 3h4l3 3v3h-7v-6ZM6 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm11 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z',
  chip: 'M8 3h8a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm-4 5h3M4 12h3M4 16h3M17 8h3M17 12h3M17 16h3',
  bell: 'M12 3a5 5 0 0 0-5 5v3.5L5.5 15h13L17 11.5V8a5 5 0 0 0-5-5Zm-2 15a2 2 0 0 0 4 0',
  chart: 'M4 20V10m5 10V4m5 16v-7m5 7V8',
  shield: 'M12 3l7 3v5c0 4.5-3 8.3-7 10-4-1.7-7-5.5-7-10V6l7-3Z',
  history: 'M3 12a9 9 0 1 0 3-6.7M3 4v4h4M12 7v5l3.5 2',
  building: 'M4 21V6l7-3v18M11 21h9V10l-9-3M7 9v0M7 13v0M7 17v0M15 12v0M15 16v0',
  users: 'M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm-7 9a7 7 0 0 1 14 0M17 11a3 3 0 1 0 0-6M18 20a6 6 0 0 0-2-4.5',

  // states
  arrow: 'M12 5v14m0-14 5 5m-5-5-5 5',
  pause: 'M9 6v12M15 6v12',
  square: 'M7 7h10v10H7z',
  slash: 'M5 19 19 5M12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18Z',
  dash: 'M6 12h12',

  // status
  check: 'M4 12.5 9 17.5 20 6.5',
  warning: 'M12 4 2.5 20h19L12 4Zm0 6v4.5M12 17.2v0',
  critical: 'M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18Zm0 4.5V13m0 3.2v0',
  info: 'M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18Zm0 5.8v0M12 11v5.5',

  // actions & chrome
  search: 'M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm5.5-1.5L21 21',
  filter: 'M3 5h18l-7 8v6l-4 2v-8L3 5Z',
  refresh: 'M20 11a8 8 0 1 0-.6 4M20 5v6h-6',
  download: 'M12 4v11m0 0 4-4m-4 4-4-4M5 19h14',
  close: 'M6 6l12 12M18 6 6 18',
  chevronRight: 'm9 6 6 6-6 6',
  chevronDown: 'm6 9 6 6 6-6',
  chevronLeft: 'm15 6-6 6 6 6',
  sun: 'M12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10ZM12 2v2m0 16v2M2 12h2m16 0h2M4.9 4.9l1.4 1.4m11.4 11.4 1.4 1.4M19.1 4.9l-1.4 1.4M6.3 17.7l-1.4 1.4',
  moon: 'M20 14.5A8.5 8.5 0 0 1 9.5 4a8.5 8.5 0 1 0 10.5 10.5Z',
  logout: 'M15 4h3a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-3M10 8 6 12l4 4M6 12h11',
  location: 'M12 21s7-6.2 7-11a7 7 0 1 0-14 0c0 4.8 7 11 7 11Zm0-8.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z',
  signal: 'M4 20v-4m5 4V11m5 9V7m5 13V3',
  thermometer: 'M12 14.8V5a2 2 0 1 1 4 0v9.8a4 4 0 1 1-4 0Z',
  satellite: 'M5 13 11 7M3.5 15.5 8.5 20.5M13 5l6 6M9 3l3 3-4 4-3-3 4-4Zm10 10 3 3-4 4-3-3 4-4Z',
  route: 'M6 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm12-10a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM8 17h6a4 4 0 0 0 0-8h-4a4 4 0 0 1 0-8',
  plus: 'M12 5v14M5 12h14',
  eye: 'M2 12s3.6-6 10-6 10 6 10 6-3.6 6-10 6-10-6-10-6Zm10 2.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z',
  table: 'M3 5h18v14H3zM3 10h18M9 10v9',
  clock: 'M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18Zm0 4.5V12l3 2',
};

const SIZES = { xs: 14, sm: 16, md: 18, lg: 22, xl: 28 };

export function Icon({ name, size = 'md', className = '', strokeWidth = 1.7, ...rest }) {
  const d = PATHS[name];
  const px = SIZES[size] || size;

  if (!d) {
    // A missing icon should be visible in development, not silently absent.
    if (import.meta.env.DEV) console.warn(`[Icon] unknown icon "${name}"`);
    return null;
  }

  return (
    <svg
      width={px}
      height={px}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      className={`shrink-0 ${className}`}
      {...rest}
    >
      <path d={d} />
    </svg>
  );
}

/** The icon that belongs to a tone — status colour never travels alone. */
export const TONE_ICON = {
  good: 'check',
  warning: 'warning',
  serious: 'warning',
  critical: 'critical',
  neutral: 'info',
  brand: 'info',
  accent: 'info',
};
